import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import Plan, { PlanType, PlanName } from 'models/Plan';

type Props = {
    planType: PlanType;
    selectedServings: number;
    handleSelectServings: (servings: number) => void;
    planName?: PlanName;
};

function SelectableServingQuantity({
  planType,
  selectedServings,
  handleSelectServings,
  planName,
}: Props): ReactElement {
  const seed = useUIDSeed();

  return (
    <fieldset>
      <div className="c-plan-select__servings">
        <legend id="plan-servings">
          Number of servings per meal
        </legend>
        <ul
          role="radiogroup"
          className="c-switch"
          aria-labelledby="plan-servings"
        >
          {planName ? (
            Plan.getServingOptionsByPlanName(planName).map((servings) => (
              <li key={seed(servings)}>
                <button
                  type="button"
                  role="radio"
                  aria-label={`Select ${servings} Serving`}
                  aria-checked={selectedServings === servings}
                  className={selectedServings === servings ? 'is-selected' : ''}
                  onClick={() => handleSelectServings(servings)}
                >
                  {servings}
                  <span className="sr-only">serving</span>
                </button>
              </li>
            ))) : (
            Plan.getServingOptions(planType).map((servings) => (
              <li key={seed(servings)}>
                <button
                  type="button"
                  role="radio"
                  aria-label={`Select ${servings} Serving`}
                  aria-checked={selectedServings === servings}
                  className={selectedServings === servings ? 'is-selected' : ''}
                  onClick={() => handleSelectServings(servings)}
                >
                  {servings}
                  <span className="sr-only">serving</span>
                </button>
              </li>
            ))
          )}
        </ul>
      </div>
    </fieldset>
  );
}

export default SelectableServingQuantity;
